import { computed } from '@vue/composition-api';
import { NavigationItem } from './components/navigation';
import { getStore } from './store';
import { useRouter } from './router';

export function useComponentBase() {
    const store = getStore(), { router, route } = useRouter();
    return {
        isMobile: computed(() => store.state.isMobile),
        isLoading: computed(() => store.state.isLoading > 0),
        isAuthenticated: computed(() => store.state.isAuthenticated),
        loggedUser: computed(() => store.state.loggedUser),
        setLoading: (isLoading: boolean) => {
            store.commit('setLoading', isLoading);
        }
    }
}

export function usePageBase() {
    const store = getStore(), { router, route } = useRouter();
    const hasRole = (role: string) => store.getters.hasRole(role);
    return {
        hasRole: hasRole,
        hasTranslatorLanguage: (lang: string) => store.getters.hasTranslatorLanguage(lang),
        setNavigation: (callback: (items: NavigationItem[], menuItems: NavigationItem[]) => void) => {
            let navigation: NavigationItem[] = [];
            let menu: NavigationItem[] = [];
            callback(navigation, menu);
            if (navigation.length > 0 || menu.length > 0) {
                store.commit('setNavigation', { navigation, menu });
            }
        },
        imagePathFromId: (id: string | number) => store.getters['media/imagePathFromId'](id),
        imageIdFromPath: (path: string) => store.getters['media/imageIdFromPath'](path),
        isUserAdmin: computed(() => hasRole("ADMIN"))
    }
}